import React, { useState, useEffect } from 'react'
import {
  Panel,
  Row,
  Col,
  ControlLabel,
  Input,
  Form,
  Message,
  IconButton,
  Icon,
  SelectPicker,
  DatePicker,
  Checkbox,
  CheckboxGroup,
} from 'rsuite'
import { isValidators, requiredFiled, getMaxLengthData } from '../../../utils/ValidatorUtils'
import ErrorMessage from '../../message/errorMessage/ErrorMessage'
import BudgetTableForm from './BudgetTableForm'
import scrollToComponent from 'react-scroll-to-component'
import NumberFormat from 'react-number-format'
import moment from 'moment'
import { DATE_PICKER_FORMAT, LOCAL_DAY_TH } from '../../../constants/date'
import { checkStatusProjectActivity, getProjectBudget } from '../../../redux/actions/budget'

import ShowLimitLength from '../../utils/ShowLimitLength'
import { numberThousandSeparator } from '../../../utils/formatterUtil'
import OverlayLoader from '../../OverlayLoader/OverlayLoader'
import { NOT_COMPLETE, RETRY_CONTACT_ADMIN } from '../../../constants/msgText'
import AlertWidget from '../../../widgets/confirm/AlertWidget'

export default function BudgetForm({
  schema: _schema,
  register,
  errors,
  Controller,
  control,
  setValue,
  clearErrors,
  formKey,
  getValues,
  projectVersionId,
  onSubmit = () => {},
  onDelete = () => {},
  onEdit = () => {},
  setIsDeleteError = () => {},
  ...props
}) {
  const { isDeleteError, delErrorMsg, isError, errorMsg, loading, hideHeader, activityOptions } =
    props

  const [schema, setSchema] = useState(_schema)
  const [section, setSection] = useState()
  const [costName, setCostName] = useState()
  const [subCostNameShow, setSubCostNameShow] = useState('0')
  const [costDetail, setCostDetail] = useState()
  const [costPerUnit, setCostPerUnit] = useState()
  const [costPerVat, setCostPerVat] = useState()
  const [startDate, setStartDate] = useState()
  const [endDate, setEndDate] = useState()
  const [quantity, setQuantity] = useState()
  const [unitOfMeasure, setUnitOfMeasure] = useState()
  const [acCostOption, setAcCostOption] = useState()
  const [activityOption, setActivityOption] = useState()
  const [costNameOption, setCostNameOption] = useState()
  const [subCostNameOption, setSubCostNameOption] = useState()
  const [isAdd, setIsAdd] = useState(false)
  const [editId, setEditId] = useState()
  const [isDeleteFail, setIsDeleteFail] = useState(false)
  const [delFailMsg, setDelFailMsg] = useState(false)
  const [isSaveError, setIsSaveError] = useState(false)
  const [validateError, setValidateError] = useState()
  const [notEnableEdit, setNotEnableEdit] = useState()
  const [personelVatType, setPersonelVatType] = useState(0)
  const [checkBoxList, setCheckBoxList] = useState()
  const [vatTypeOption, setVatTypeOption] = useState([])
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = projectVersionId || sessionStorage.getItem('projectId')
  const [rowStyle, setRowStyle] = useState({})
  const [costDetailValue, setCostDetailValue] = useState(0)
  const [costNameValue, setCostNameValue] = useState(0)
  const [txtButton, setTxtButton] = useState(_schema?.header?.split(' '))
  const [isLoading, setIsLoading] = useState(loading)
  const [limitCost, setLimitCost] = useState()
  const [editTotal, setEditTotal] = useState()

  const selectedId = 'selectedId'

  useEffect(() => {
    setSchema(_schema)
    setIsAdd(isError)
    setIsDeleteFail(isDeleteError)
    setDelFailMsg(delErrorMsg)
    // handleCallActivity()
  }, [_schema])

  useEffect(() => {
    if (schema?.personelVatType?.options) {
      setOption()
    }
  }, [])

  useEffect(() => {
    setIsSaveError(isError)
    setIsAdd(isError)
  }, [isError])

  useEffect(() => {
    setIsDeleteFail(isDeleteError)
    setDelFailMsg(delErrorMsg)
    if (isDeleteError) {
      setValidateError('')
    }
  }, [isDeleteError, delErrorMsg])

  const setOption = () => {
    const arr = []
    arr.push(schema?.personelVatType?.options[0])
    setVatTypeOption(arr)
  }

  const onAdd = () => {
    setValue(selectedId, -1)

    setCostDetailValue(0)
    setCostNameValue(0)
    setActivityOption('')
    setStartDate('')
    setEndDate('')
    setCostName('')
    setCostDetail('')
    setCostPerUnit('')
    setCostPerVat('')
    setPersonelVatType('0')
    setQuantity('')
    setUnitOfMeasure('')
    setAcCostOption('')
    setEditId('')
    setIsAdd(true)
    setIsSaveError(false)
    setIsDeleteFail(false)
    setIsDeleteError(false)
    setDelFailMsg('')
    scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })

    setLimitCost()
    setEditTotal()

    schema.personelVatType && handleChange('')
  }

  const handleCallActivity = async () => {
    if (!schema?.activityOption && schema.name === 'activityBudget') {
      schema.activityOption = {}
      const res = await getProjectBudget(projectId)

      let activityOption = {
        name: 'activityOption',
        label: 'กิจกรรม',
        value: '',
        validators: [{ type: 'REQUIRED', value: null, errorMessage: 'กรุณาเลือกกิจกรรม' }],
        options: [],
      }
      if (res.forms.activity?.value) {
        res.forms.activity?.value.map((item, index) => {
          activityOption.options.push({
            label: item.activity,
            value: item.id,
          })
        })
      }

      schema.activityOption = activityOption
      setRowStyle({
        marginTop: -20,
      })
    }
  }

  const handleEdit = async (data) => {
    console.log(data)
    setIsLoading(true)
    setNotEnableEdit(false)
    setValidateError('')
    setIsDeleteFail(false)
    setIsDeleteError(false)
    setDelFailMsg('')
    try {
      const response = await checkStatusProjectActivity(projectId, data.activityId, data.id)

      // console.log('response : ', response)

      if (response) {
        setEditTotal(response.totalCost - data.sumPrice)
        setLimitCost(Number(response.sumCost))
        setEditValue(data)
      } else {
        setValidateError(
          `เกิดข้อผิดพลาดไม่สามารถเช็คค่าใช้จ่ายกิจกรรมของระบบบันทึกรับจ่าย กรุณาลองใหม่อีกครั้งหรือติดต่อผู้ดูแลระบบ`
        )
      }
    } catch (e) {
      // console.log(e?.response?.data?.errors?.message)
      let errorMessage = e?.response?.data?.errors?.message
      setValidateError(
        errorMessage ||
          `เกิดข้อผิดพลาดไม่สามารถเช็คค่าใช้จ่ายกิจกรรมของระบบบันทึกรับจ่าย กรุณาลองใหม่อีกครั้งหรือติดต่อผู้ดูแลระบบ`
      )
    }

    setIsLoading(false)
  }

  const setEditValue = (data) => {
    // console.log('handleEdit data => ', formKey, data)

    formKey === 'subForms_1' && data.costName === 'ค่าบริหารจัดการสำนักงาน'
      ? setSubCostNameShow(2)
      : setSubCostNameShow(1)

    setActivityOption(data.activityId)
    setCostName(data.costName)
    setCostDetailValue(data?.costDetail?.length || 0)
    setCostNameValue(data?.costName?.length || 0)
    setCostDetail(data.costDetail)
    setCostPerUnit(data.costPerUnit)
    setCostPerVat(data.costPerVat)
    setQuantity(data.quantity)
    setAcCostOption(data.acCostOption || data.costName)
    setCostNameOption(data.costName)
    setSubCostNameOption(data.subCostName)
    setUnitOfMeasure(data.unitOfMeasure)
    setStartDate(moment(data.startDate, 'DD/MM/YYYY').toDate().toLocaleDateString('en-ZA'))
    setEndDate(moment(data.endDate, 'DD/MM/YYYY').toDate().toLocaleDateString('en-ZA'))
    data?.personelVatType?.length > 0 && handleChange(data.personelVatType)
    setEditId(data.id)
    setIsAdd(true)
    setIsSaveError(false)
    setIsDeleteFail(false)
    setIsDeleteError(false)
    setDelFailMsg('')
    scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })

    setValue(selectedId, data.id)
    schema.costName && setValue(schema.costName.name, data.costName)
    schema.subCostName && setValue(schema.subCostName.name, data.subCostName)
    setValue(schema.activityOption.name, data.activityId)
    setValue(schema.costDetail.name, data.costDetail)
    setValue(schema.costPerUnit.name, data.costPerUnit)
    setValue(schema.quantity.name, data.quantity)
    schema.acCostOption && setValue(schema.acCostOption.name, data.acCostOption || data.costName)
    schema.unitOfMeasure && setValue(schema.unitOfMeasure.name, data.unitOfMeasure)
    schema.costPerVat && setValue(schema.costPerVat.name, data.costPerVat)
    schema?.costTime?.startDate &&
      setValue(
        schema.costTime.startDate.name,
        moment(data.startDate, 'DD/MM/YYYY').toDate().toLocaleDateString('en-ZA')
      )
    schema?.costTime?.endDate &&
      setValue(
        schema.costTime.endDate.name,
        moment(data.endDate, 'DD/MM/YYYY').toDate().toLocaleDateString('en-ZA')
      )
  }

  const handleChange = (value) => {
    if (value.length === 0) {
      setValue(schema.personelVatType.name)
      setPersonelVatType(0)
      setOption()
      setCheckBoxList()
    } else {
      if (value[0] == 2) {
        while (value.length) {
          value.pop()
        }

        setCheckBoxList(value)
        setOption()
      } else {
        setValue(schema.personelVatType.name, value)

        value.forEach((selected) => {
          if (selected == 1) {
            setPersonelVatType(1)
            setVatTypeOption(schema?.personelVatType?.options)
          } else if (selected == 2) {
            setPersonelVatType(0)
          }
        })

        setCheckBoxList(value)
      }
    }
  }

  const generateCheckbox = () => {
    return vatTypeOption.map((item, index) => {
      return (
        <>
          <Checkbox value={item.value} disabled={item.disabled} key={index}>
            {item.label}
          </Checkbox>
        </>
      )
    })
  }

  return (
    <>
      <Panel
        header={hideHeader ? '' : schema.header}
        style={{ marginBottom: 5 }}
        ref={(section) => {
          setSection(section)
        }}
      >
        {isAdd && (
          <Form fluid style={{ marginTop: hideHeader ? -20 : 0 }}>
            {schema.categoryType && (
              <>
                <Input
                  name="categoryType"
                  defaultValue={schema.categoryType}
                  inputRef={register()}
                  style={{ display: 'none' }}
                />
              </>
            )}

            <Controller
              key={selectedId}
              name={selectedId}
              control={control}
              defaultValue={editId}
            />
            <Row style={rowStyle}>
              {schema.message && (
                <Row style={{ marginTop: 10 }}>
                  {schema.message.map((item, index) => {
                    return (
                      <Message
                        showIcon
                        type={item.type}
                        description={item.description}
                        key={index}
                      />
                    )
                  })}
                </Row>
              )}

              {schema.personelVatType && (
                <>
                  <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: 45 }}>
                    <ErrorMessage error={errors[schema.personelVatType.name]} />
                    <ControlLabel>
                      {requiredFiled(
                        schema.personelVatType.validators,
                        schema.personelVatType.label
                      )}
                    </ControlLabel>
                  </Col>
                  <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: 15 }}>
                    {vatTypeOption && (
                      <Controller
                        key={schema.personelVatType.name}
                        name={schema.personelVatType.name}
                        control={control}
                        rules={isValidators(schema.personelVatType.validators)}
                        defaultValue={checkBoxList}
                        render={(props) => {
                          return (
                            <CheckboxGroup
                              inline
                              name={schema.personelVatType.name}
                              value={checkBoxList}
                              onChange={handleChange}
                            >
                              {generateCheckbox()}
                            </CheckboxGroup>
                          )
                        }}
                      />
                    )}
                  </Col>
                </>
              )}

              {schema.costName && (
                <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: 15 }}>
                  {schema.costName.options ? (
                    <>
                      <ErrorMessage error={errors[schema.costName.name]} />
                      <ControlLabel>
                        {requiredFiled(schema.costName.validators, schema.costName.label)}
                      </ControlLabel>
                      <Controller
                        name={schema.costName.name}
                        control={control}
                        defaultValue={costNameOption}
                        rules={isValidators(schema.costName.validators)}
                        render={(props) => {
                          return (
                            <SelectPicker
                              data={schema.costName.options}
                              value={props.value}
                              style={{ marginTop: '3px', width: '100%' }}
                              searchable={false}
                              placeholder="เลือก"
                              disabled={limitCost > 0}
                              onChange={(value) => {
                                if (value === 'ค่าบริหารจัดการสำนักงาน') {
                                  setSubCostNameShow(2)
                                } else {
                                  setSubCostNameShow(1)
                                }

                                props.onChange(value)
                              }}
                            />
                          )
                        }}
                      />

                      {subCostNameShow == 2 && schema.subCostName.options && (
                        <>
                          <br />
                          <br />
                          <ErrorMessage error={errors[schema.subCostName.name]} />
                          <ControlLabel>
                            {requiredFiled(schema.subCostName.validators, schema.subCostName.label)}
                          </ControlLabel>
                          <Controller
                            name={schema.subCostName.name}
                            control={control}
                            defaultValue={subCostNameOption}
                            rules={isValidators(schema.subCostName.validators)}
                            render={(props) => {
                              return (
                                <SelectPicker
                                  data={schema.subCostName.options}
                                  value={props.value}
                                  style={{ marginTop: '3px', width: '100%' }}
                                  searchable={false}
                                  placeholder="เลือก"
                                  disabled={limitCost > 0}
                                  onChange={(value) => {
                                    // setSubCostName(value)
                                    props.onChange(value)
                                  }}
                                />
                              )
                            }}
                          />
                        </>
                      )}
                    </>
                  ) : (
                    <>
                      {formKey != 'managementFeeWidget_1' && schema?.name != 'activityBudget' && (
                        <>
                          <ErrorMessage error={errors[schema.costName.name]} />
                          <ControlLabel>
                            {requiredFiled(schema.costName.validators, schema.costName.label)}
                          </ControlLabel>
                          <Input
                            name={schema.costName.name}
                            defaultValue={costName}
                            placeholder={schema.costName.hint}
                            maxLength={getMaxLengthData(schema.costName.validators)?.value || 250}
                            inputRef={register(isValidators(schema.costName.validators))}
                            onChange={(value) => {
                              setCostName(value)
                              setCostNameValue(value.length)
                            }}
                          />
                          <ShowLimitLength
                            textLength={costNameValue}
                            maxLength={getMaxLengthData(schema.costName.validators)?.value || 250}
                          />
                        </>
                      )}
                    </>
                  )}
                </Col>
              )}

              {formKey === 'ActivityCost' && (
                <>
                  {schema.activityOption && (
                    <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: 15 }}>
                      <ErrorMessage error={errors[schema.activityOption.name]} />
                      <ControlLabel>
                        {requiredFiled(
                          schema.activityOption.validators,
                          schema.activityOption.label
                        )}
                      </ControlLabel>
                      <Controller
                        key={schema.activityOption.name}
                        name={schema.activityOption.name}
                        control={control}
                        rules={isValidators(schema.activityOption.validators)}
                        defaultValue={activityOption}
                        render={(props) => {
                          return (
                            <SelectPicker
                              data={
                                schema.activityOption.options.length === 0
                                  ? activityOptions
                                  : schema.activityOption.options.length
                              }
                              value={props.value}
                              block
                              searchable={false}
                              placeholder="เลือก"
                              disabled={limitCost > 0}
                              onChange={(value) => {
                                props.onChange(value)
                                setActivityOption(value)
                              }}
                            />
                          )
                        }}
                      />
                    </Col>
                  )}

                  <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: 15 }}>
                    <ErrorMessage error={errors[schema.acCostOption.name]} />
                    <ControlLabel>
                      {requiredFiled(schema.acCostOption.validators, schema.acCostOption.label)}
                    </ControlLabel>
                    <Controller
                      key={schema.acCostOption.name}
                      name={schema.acCostOption.name}
                      control={control}
                      rules={isValidators(schema.acCostOption.validators)}
                      defaultValue={acCostOption}
                      // value={acCostOption}
                      render={(props) => {
                        return (
                          <SelectPicker
                            data={schema.acCostOption.options}
                            value={props.value}
                            block
                            searchable={false}
                            placeholder="เลือก"
                            disabled={limitCost > 0}
                            onChange={(value) => {
                              props.onChange(value)
                              setAcCostOption(value)
                            }}
                          />
                        )
                      }}
                    />
                  </Col>
                </>
              )}

              <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: 15 }}>
                <ErrorMessage error={errors[schema.costDetail.name]} />
                <ControlLabel>
                  {requiredFiled(schema.costDetail.validators, schema.costDetail.label)}
                </ControlLabel>
                {/* <ControlLabel>{schema.costDetail.label}</ControlLabel> */}
                <Controller
                  key={schema.costDetail.name}
                  name={schema.costDetail.name}
                  control={control}
                  rules={isValidators(schema.costDetail.validators)}
                  defaultValue={costDetail}
                  render={(props) => {
                    return (
                      <>
                      <Input
                        //name={schema.costDetail.name}
                        rows={3}
                        componentClass="textarea"
                        defaultValue={props.value}
                        placeholder={schema.costDetail.hint}
                        //inputRef={register(isValidators(schema.costDetail.validators))}
                        maxLength={getMaxLengthData(schema.costDetail.validators)?.value || 1000}
                        onChange={(value) => {
                          props.onChange(value)
                          setCostDetailValue(value?.length || 0)
                          setCostDetail(value)
                        }}
                        value={props.value}
                        disabled={limitCost > 0}
                      />
                      <ShowLimitLength
                        textLength={costDetailValue}
                        maxLength={getMaxLengthData(schema.costDetail.validators)?.value || 1000}
                      />
                      </>
                    )
                  }}
                  />
                
              </Col>

              {schema.costTime && (
                <>
                  <Col xs={24} sm={24} md={12} lg={12} style={{ marginTop: 15 }}>
                    <ControlLabel>{schema.costTime.startDate.label}</ControlLabel>
                    <Controller
                      key={schema.costTime.startDate.name}
                      name={schema.costTime.startDate.name}
                      control={control}
                      rules={isValidators(schema.costTime.startDate.validators)}
                      defaultValue={startDate}
                      render={(props) => {
                        return (
                          <DatePicker
                            format={DATE_PICKER_FORMAT}
                            locale={LOCAL_DAY_TH}
                            block
                            placement="bottomStart"
                            disabled={schema.costTime.startDate.disabled}
                            disabledDate={(date) =>
                              getValues(schema.costTime.endDate.name) &&
                              moment(getValues(schema.costTime.endDate.name)).isBefore(
                                date,
                                new Date()
                              )
                            }
                            value={startDate}
                            onChange={(value) => {
                              props.onChange(value)
                              let date
                              value && (date = value.toLocaleDateString('en-ZA'))
                              // calMonth(value, 'start')
                              setStartDate(value)
                              setValue(schema.costTime.startDate.name, date)
                              clearErrors(schema.costTime.startDate.name)
                              // console.log('xxx => ', date)
                            }}
                            onClean={() => {
                              setValue(schema.costTime.startDate.name)
                            }}
                          />
                        )
                      }}
                    />
                  </Col>
                  <Col xs={24} sm={24} md={12} lg={12} style={{ marginTop: 15 }}>
                    <ControlLabel>{schema.costTime.endDate.label}</ControlLabel>
                    <Controller
                      key={schema.costTime.endDate.name}
                      name={schema.costTime.endDate.name}
                      control={control}
                      rules={isValidators(schema.costTime.endDate.validators)}
                      defaultValue={endDate}
                      render={(props) => {
                        return (
                          <DatePicker
                            format={DATE_PICKER_FORMAT}
                            locale={LOCAL_DAY_TH}
                            block
                            placement="bottomStart"
                            disabled={schema.costTime.endDate.disabled}
                            disabledDate={(date) =>
                              getValues(schema.costTime.startDate.name) &&
                              moment(getValues(schema.costTime.startDate.name)).isAfter(
                                date,
                                new Date()
                              )
                            }
                            name={schema.costTime.endDate.name}
                            value={endDate}
                            onChange={(value) => {
                              let date
                              value && (date = value.toLocaleDateString('en-ZA'))
                              // calMonth(value, 'end')
                              setEndDate(value)
                              setValue(schema.costTime.endDate.name, date)
                              clearErrors(schema.costTime.endDate.name)
                            }}
                            onClean={() => {
                              setValue(schema.costTime.endDate.name)
                            }}
                          />
                        )
                      }}
                    />
                  </Col>
                </>
              )}

              {limitCost > 0 && (
                <Col xs={24} sm={24} md={24} lg={24}>
                  <Message
                    type="warning"
                    showIcon
                    style={{ marginTop: 10 }}
                    description={`แก้ไขยอดรวมแล้วต้องไม่ต่ำกว่า ${numberThousandSeparator(
                      limitCost
                    )} ${
                      editTotal > 0 ? ` ยอดที่มีอยู่แล้ว ${numberThousandSeparator(editTotal)}` : ''
                    }`}
                  />
                </Col>
              )}

              <Col
                xs={24}
                sm={24}
                md={schema.unitOfMeasure || personelVatType == 1 ? 8 : 12}
                lg={schema.unitOfMeasure || personelVatType == 1 ? 8 : 12}
                style={{ marginTop: 15 }}
              >
                <ErrorMessage error={errors[schema?.costPerUnit?.name]} />
                <ControlLabel>
                  {personelVatType == 1
                    ? requiredFiled(schema.costPerUnit.subValidators, schema.costPerUnit.subLabel)
                    : requiredFiled(schema.costPerUnit.validators, schema.costPerUnit.label)}
                </ControlLabel>
                <Controller
                  key={schema.costPerUnit.name}
                  name={schema.costPerUnit.name}
                  control={control}
                  rules={isValidators(schema.costPerUnit.validators)}
                  defaultValue={costPerUnit}
                  render={(props) => {
                    return (
                      <NumberFormat
                        className="rs-input"
                        disabled={schema.costPerUnit.disabled}
                        placeholder={schema.costPerUnit.hint}
                        thousandSeparator={true}
                        value={props.value}
                        onValueChange={(value) => {
                          props.onChange(value.floatValue)
                          setCostPerUnit(value.floatValue)

                          if (personelVatType == 1 && schema?.costPerVat) {
                            let costPerVat = numberThousandSeparator(
                              (quantity * value.floatValue * 7) / 107
                            )
                            setCostPerVat(costPerVat)
                            setValue(schema.costPerVat.name, costPerVat)
                          }
                        }}
                      />
                    )
                  }}
                />
              </Col>

              {personelVatType == 1 && schema?.costPerVat && (
                <>
                  <Col xs={24} sm={24} md={8} lg={8} style={{ marginTop: 15 }}>
                    <ErrorMessage error={errors[schema?.costPerVat?.name]} />
                    <ControlLabel>
                      {requiredFiled(schema.costPerVat.validators, schema.costPerVat.label)}
                    </ControlLabel>
                    <Controller
                      key={schema.costPerVat.name}
                      name={schema.costPerVat.name}
                      control={control}
                      rules={isValidators(schema.costPerVat.validators)}
                      defaultValue={costPerVat}
                      render={(props) => {
                        return (
                          <NumberFormat
                            className="rs-input"
                            disabled={schema.costPerVat.disabled}
                            placeholder={schema.costPerVat.hint}
                            thousandSeparator={true}
                            value={props.value}
                            onValueChange={(value) => {
                              props.onChange(value.floatValue)
                              setCostPerVat(value.floatValue)
                            }}
                          />
                        )
                      }}
                    />
                  </Col>
                </>
              )}

              <Col
                xs={24}
                sm={24}
                md={schema.unitOfMeasure || personelVatType == 1 ? 8 : 12}
                lg={schema.unitOfMeasure || personelVatType == 1 ? 8 : 12}
                style={{ marginTop: 15 }}
              >
                <ErrorMessage error={errors[schema?.quantity?.name]} />
                <ControlLabel>
                  {requiredFiled(schema.quantity.validators, schema.quantity.label)}
                </ControlLabel>
                <Controller
                  key={schema.quantity.name}
                  name={schema.quantity.name}
                  control={control}
                  rules={isValidators(schema.quantity.validators)}
                  defaultValue={quantity}
                  render={(props) => {
                    return (
                      <NumberFormat
                        className="rs-input"
                        disabled={schema.quantity.disabled}
                        placeholder={schema.quantity.hint}
                        thousandSeparator={true}
                        value={props.value}
                        onValueChange={(value) => {
                          props.onChange(value.floatValue)
                          setQuantity(value.floatValue)

                          if (personelVatType == 1 && schema?.costPerVat) {
                            let costPerVat = numberThousandSeparator(
                              (costPerUnit * value.floatValue * 7) / 107
                            )
                            setCostPerVat(costPerVat)
                            setValue(schema.costPerVat.name, costPerVat)
                          }
                        }}
                      />
                    )
                  }}
                />
              </Col>
              {schema.unitOfMeasure && (
                <Col xs={24} sm={24} md={8} lg={8} style={{ marginTop: 15 }}>
                  <ControlLabel>
                    {requiredFiled(
                      schema.unitOfMeasure.validators,
                      schema.unitOfMeasure.label + ' (ลักษณะนาม)'
                    )}
                  </ControlLabel>
                  <Input
                    name={schema.unitOfMeasure.name}
                    defaultValue={unitOfMeasure}
                    placeholder={'เช่น ครั้ง รอบ คน เดือน หน่วย'}
                    inputRef={register(isValidators(schema.unitOfMeasure.validators))}
                    onChange={(value) => {
                      setUnitOfMeasure(value)
                    }}
                  />
                </Col>
              )}
            </Row>

            {isSaveError && (
              <Row style={{ marginTop: 10 }}>
                <Message
                  showIcon
                  type="error"
                  description={
                    errorMsg
                      ? errorMsg
                      : `บันทึก ${
                          schema.buttonText ? schema.buttonText : ''
                        } ไม่สำเร็จ กรุณาลองใหม่อีกครั้งหรือติดต่อผู้ดูแลระบบ`
                  }
                />
              </Row>
            )}

            <Row style={{ marginTop: 10 }}>
              <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: 5, marginBottom: 5 }}>
                <div>
                  <IconButton
                    appearance="ghost"
                    // className={editId ? 'rs-btn-ghost-edit' : ''}
                    icon={
                      <Icon
                        appearance="ghost"
                        icon={editId ? 'edit' : 'save'}
                        // className={editId ? 'bt-gost-icon-radius-edit' : 'bt-gost-icon-radius'}
                        className={'bt-gost-icon-radius'}
                      />
                    }
                    onClick={onSubmit}
                    style={{ marginRight: 5 }}
                    disabled={loading}
                  >
                    {`${editId ? 'บันทึกแก้ไข' : 'บันทึก'}${txtButton[1]}`}
                  </IconButton>
                  <IconButton
                    appearance="ghost"
                    className="rs-btn-ghost-cancel"
                    icon={<Icon className="bt-gost-icon-radius-cancel" icon="close" />}
                    onClick={(e) => {
                      setIsAdd(false)
                      setIsSaveError(false)
                      setCheckBoxList()
                      scrollToComponent(section, { offset: 1, align: 'top', duration: 500 })
                    }}
                    style={{ marginRight: 5 }}
                    disabled={loading}
                  >
                    {`ยกเลิก${editId ? 'แก้ไข' : 'บันทึก'}${txtButton[1]}`}
                  </IconButton>
                </div>
              </Col>
            </Row>
          </Form>
        )}

        {/* {console.log('!isAdd : ', !isAdd)} */}
        {!isAdd && (
          // <Row style={{ marginTop: 10 }}>
          //   <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: 5, marginBottom: 5 }}>
          <div>
            <IconButton
              appearance="ghost"
              icon={<Icon className="bt-gost-icon-radius" icon="plus" />}
              onClick={onAdd}
              style={{ marginRight: 5 }}
            >
              {`เพิ่ม ${txtButton[1]}`}
            </IconButton>
          </div>
          //   </Col>
          // </Row>
        )}
        {isDeleteFail && (
          <Row style={{ marginTop: 10 }}>
            <Message
              showIcon
              type="error"
              description={
                delFailMsg ||
                `ลบ ${
                  schema.buttonText ? schema.buttonText : ''
                } ${NOT_COMPLETE} ${RETRY_CONTACT_ADMIN}`
              }
              closable
              onClose={() => {
                setDelFailMsg('')
                setIsDeleteFail(false)
                setIsDeleteError(false)
              }}
            />
          </Row>
        )}
        {validateError && (
          <Row style={{ marginTop: 10 }}>
            <Message
              closable
              showIcon
              type="error"
              description={validateError}
              onClose={() => {
                setValidateError('')
              }}
            />
          </Row>
        )}

        <Row style={{ marginTop: 10 }}>
          <BudgetTableForm
            schema={schema}
            isEdit={true}
            handleDelete={onDelete}
            handleEdit={handleEdit}
          />
        </Row>
      </Panel>
      {(loading || isLoading) && <OverlayLoader />}

      {/* {notEnableEdit && ( */}
      <AlertWidget
        title={'แจ้งเตือน'}
        show={notEnableEdit}
        detail={`ค่าใช้จ่ายกิจกรรมถูกใช้หมดแล้ว ไม่สามารถแก้ไขได้`}
        onClose={() => {
          setNotEnableEdit(false)
        }}
      />
      {/* )} */}
    </>
  )
}
